export default __webpack_public_path__ + "static/media/operating.b28c1cee.svg";